import {
    Dimension,
    Issue,
    Location,
    PermissionResourceType,
    Property,
    Solution,
    WorkSpecification
} from "../../../../models";

import DataStoreDimensionDAOFactory from "../../../dimension/dao/datastore/DataStoreDimensionDAOFactory";
import DataStoreIssueDAOFactory from "../../../issue/dao/datastore/DataStoreIssueDAOFactory";
import DataStoreLocationDAOFactory from "../../../location/dao/datastore/DataStoreLocationDAOFactory";
import DataStorePropertyDAOFactory from "../../../property/dao/datastore/DataStorePropertyDAOFactory";
import DataStoreWorkScopeSpecificationDAOFactory from "../../../design/workscopespecification/dao/datastore/DataStoreWorkScopeSpecificationDAOFactory";
import { EntityResolver } from "./EntityResolver";
import GraphQLSolutionDAOFactory from "../../../solution/majorVersion/dao/GraphQLSolutionDAOFactory";
import { ResourceEntityResolver } from "./ResourceEntityResolver";

const propertyDAO = DataStorePropertyDAOFactory.getInstance();
const issueDAO = DataStoreIssueDAOFactory.getInstance();
const locationDAO = DataStoreLocationDAOFactory.getInstance();
const dimensionDAO = DataStoreDimensionDAOFactory.getDimensionDAO();
const workSpecificationDAO = DataStoreWorkScopeSpecificationDAOFactory.getInstance();
const solutionDAO = GraphQLSolutionDAOFactory.getInstance();

export const resourceTypeToEntityResolverMap = new Map<PermissionResourceType, EntityResolver>([
    [PermissionResourceType.PROPERTY, new ResourceEntityResolver<Property>((id) => propertyDAO.getById(id))],
    [PermissionResourceType.ISSUE, new ResourceEntityResolver<Issue>((id) => issueDAO.getIssueById(id))],
    [PermissionResourceType.LOCATION, new ResourceEntityResolver<Location>((id) => locationDAO.getLocationById(id))],
    [PermissionResourceType.DIMENSION, new ResourceEntityResolver<Dimension>((id) => dimensionDAO.getDimensionById(id))],
    [PermissionResourceType.WORK_SPECIFICATION, new ResourceEntityResolver<WorkSpecification>((id) => workSpecificationDAO.getById(id))],
    [PermissionResourceType.SOLUTION, new ResourceEntityResolver<Solution>((id) => solutionDAO.getById(id))]
]);